module.exports = __webpack_public_path__ + "static/img/bg-4.2f73c34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/bg-4.jpg
// module id = 8aSp
// module chunks = 1